import { HierarchyPrimary } from 'stories/Button.stories';
import cn from 'classnames';
import viewAllLogo from '@assets/bytes/viewMore.svg';
import Image from 'next/image';

const ViewAll = ({ className, href }) => {
  return (
    <HierarchyPrimary
      label={'View All'}
      linkCTA
      href={href ?? '/bytes'}
      customStyle={cn(className)}
    >
      <Image src={viewAllLogo} width={16} height={16} />
    </HierarchyPrimary>
  );
};

export default ViewAll;
